import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { shareActions } from "redux/slices/shareSlice";
//
import xImage from "../../assets/images/XImage.svg";
import twitterIcon from "../../assets/images/icons8-twitter.svg";
import whatsAppIcon from "../../assets/images/whatsapp-icon.svg";
import redditIcon from "../../assets/images/icons8-reddit.png";
import telegramIcon from "../../assets/images/telegram-5945.svg";
import greenCopy from "../../assets/images/wt-green-copy.svg";
import { useTranslation } from "react-i18next";

function SharePopup() {
  const { t } = useTranslation();
  const [copySuccessText, setCopySuccessText] = useState(null);
  const dispatch = useDispatch();

  const { show, data } = useSelector((state) => state.share || {});
  const url = data?.url ?? "";
  // const title = data?.title;
  const text = data?.text ?? "";

  const onClose = () => {
    dispatch(shareActions.removeShareURL(""));
  };

  const copyHandler = (e) => {
    e.stopPropagation();

    if (navigator && navigator.clipboard && navigator.clipboard.writeText)
      navigator.clipboard.writeText(text).then(() => {
        setCopySuccessText(t("copied"));
        setTimeout(() => setCopySuccessText(null), 2000);
      });
  };

  const openInNewTab = (shareURL) => {
    window.open(encodeURI(shareURL), "_blank").focus();
  };

  const onTwitterShare = () => {
    openInNewTab(`https://twitter.com/intent/tweet?url=${url}&text=${text}`);
  };

  // not possible to share text
  const onWhatsAppShare = () => {
    openInNewTab(`https://wa.me/?text=${text}&app_absent=1`);
  };

  const onRedditShare = () => {
    openInNewTab(`https://www.reddit.com/submit?url=${url}&title=${text}`);
  };

  const onTelegramShare = () => {
    openInNewTab(`https://t.me/share/url?url=${url}&text=${text}`);
  };

  return show ? (
    <div className="popUpOverlay">
      <div className="popUpCard initialOverflow switchNumberPopup">
        <div className="shareContainer">
          <div className="s-top">
            <h1>{t("codeRewards")}</h1>
            <img src={xImage} alt="" onClick={onClose} />
          </div>
          <div className="s-middle mt-30">
            <div onClick={onTwitterShare}>
              <img
                style={{ background: "#11a8ff33" }}
                src={twitterIcon}
                alt=""
              />
              <h3>{t("twitter")}</h3>
            </div>
            <div onClick={onWhatsAppShare}>
              <img
                style={{ background: "#09b43633" }}
                src={whatsAppIcon}
                alt=""
              />
              <h3>{t("whatsApp")}</h3>
            </div>
            <div onClick={onRedditShare}>
              <img
                style={{ background: "#fa562233" }}
                src={redditIcon}
                alt=""
              />
              <h3>{t("reddit")}</h3>
            </div>
            <div onClick={onTelegramShare}>
              <img
                style={{ background: "#008cd733" }}
                src={telegramIcon}
                alt=""
              />
              <h3>{t("telegram")}</h3>
            </div>
          </div>
          <div className="s-bottom mt-30">
            <h2>{t("copyMessage")}</h2>
            <div className="linkBox">
              <p className="url">{text}</p>
              {copySuccessText ? (
                <span>{copySuccessText}</span>
              ) : (
                <img
                  onClick={copyHandler}
                  src={greenCopy}
                  className="copyImageCustom"
                  alt="copy"
                  title="Copy Message"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
}

export default SharePopup;
